module.exports = {"id":"dp3_2l1q3","text":"Integrating and re-elaborating digital content","instructions":"Which example best represents editable digital content?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.2","questionType":"PickOne","random":true,"options":[{"id":"dp3_2l1q3-a1","text":"A text document with editing permissions","score":1.8},{"id":"dp3_2l1q3-a2","text":"A locked image file without edit access","score":0},{"id":"dp3_2l1q3-a3","text":"A scanned PDF with no text layer","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.2/l1q3.json
// module id = 1132
// module chunks = 41